export var VL_ONLY_GUIDE_CONFIG = ['shortTimeLabels'];